<script>
import AkButtonActionV2 from '@components/v2/general/AkButtonActionV2.vue';

export default {
  components: {AkButtonActionV2},
  props: {
    validateLabel: {
      type: String,
      required: true,
    },
  },
  emits: ['action', 'reset'],
  methods: {
    clickAction() {
      this.$emit('action');
    },
    reset() {
      this.$emit('reset');
    },
  },
};
</script>

<template>
  <div class="grid grid-cols-4 gap-6 items-center">
    <i
      v-on:click="this.reset()"
      class="ga-icon ga-refresh text-3xl text-grey-400 hover:text-secondary hover:cursor-pointer col-start-2 col-end-2 justify-self-end" />
    <AkButtonActionV2
      :label="this.validateLabel"
      class="col-start-3 col-end-5 btn-blue"
      :little="false"
      @click="clickAction" />
  </div>
</template>
